import type { Cocktail } from './Types.ts';

export const cocktails: ReadonlyArray<Cocktail> = [
  // ── Non-alcoholic ──────────────────────────────────────────
  {
    name: 'Coffee',
    ingredients: ['coffee'],
    strength: 0,
    signature: false,
    nonalcoholic: true,
  },
  {
    name: 'Tea',
    ingredients: ['tea'],
    strength: 0,
    signature: false,
    nonalcoholic: true,
  },
  {
    name: 'Hot Tang',
    ingredients: ['tang'],
    strength: 0,
    signature: false,
    nonalcoholic: true,
  },
  {
    name: 'Hot Cocoa',
    ingredients: ['cocoa'],
    strength: 0,
    signature: false,
    nonalcoholic: true,
  },
  {
    name: 'Athletic non-alcoholic beer',
    ingredients: ['athletic'],
    strength: 0,
    signature: false,
    nonalcoholic: true,
  },
  {
    name: 'Olipop',
    ingredients: ['olipop'],
    strength: 0,
    signature: false,
    nonalcoholic: true,
  },
  {
    name: 'Izze',
    ingredients: ['izze'],
    strength: 0,
    signature: false,
    nonalcoholic: true,
  },
  {
    name: 'Poppi',
    ingredients: ['poppi'],
    strength: 0,
    signature: false,
    nonalcoholic: true,
  },
  {
    name: 'Humm Kombucha',
    ingredients: ['humm'],
    strength: 0,
    signature: false,
    nonalcoholic: true,
  },
  {
    name: 'Coca-Cola',
    ingredients: ['cola'],
    strength: 0,
    signature: false,
    nonalcoholic: true,
  },
  {
    name: 'Fever-tree Elderflower Tonic',
    ingredients: ['fever-tree elderflower tonic'],
    strength: 0,
    signature: false,
    nonalcoholic: true,
  },
  {
    name: 'Fever-tree Indian Tonic',
    ingredients: ['fever-tree tonic'],
    strength: 0,
    signature: false,
    nonalcoholic: true,
  },
  {
    name: 'Fever-tree Blood Orange Soda',
    ingredients: ['fever-tree blood orange soda'],
    strength: 0,
    signature: false,
    nonalcoholic: true,
  },
  {
    name: 'Fever-tree Lemonade',
    ingredients: ['fever-tree lemonade'],
    strength: 0,
    signature: false,
    nonalcoholic: true,
  },
  {
    name: 'Sparkling water',
    ingredients: [],
    strength: 0,
    signature: false,
    nonalcoholic: true,
  },

  // ── Signature cocktails ────────────────────────────────────
  {
    name: 'The LJ 75',
    ingredients: ['gin', 'champagne', 'lemon', 'elderflower liqueur'],
    strength: 2,
    signature: true,
    nonalcoholic: false,
    recipe: { gin: 2, champagne: 4, lemon: 1, 'elderflower liqueur': 2 },
  },
  {
    name: 'Raspberry Beret',
    ingredients: ['vanilla vodka', 'lime', 'chambord', 'simple syrup'],
    strength: 3,
    signature: true,
    nonalcoholic: false,
    recipe: { 'vanilla vodka': 2, lime: 1, chambord: 1, 'simple syrup': 0.5 },
  },
  {
    name: 'Rome with a View',
    ingredients: [
      'campari',
      'dry vermouth',
      'club soda',
      'lime',
      'simple syrup',
    ],
    strength: 1,
    signature: true,
    nonalcoholic: false,
  },
  {
    name: 'Rosé the Riveter',
    ingredients: [
      'gin',
      'pomegranate liqueur',
      'simple syrup',
      'lemon',
      'rose wine',
    ],
    strength: 3,
    signature: true,
    nonalcoholic: false,
    recipe: {
      gin: 1.5,
      'pomegranate liqueur': 0.75,
      'simple syrup': 0.5,
      lemon: 0.5,
      'rose wine': 2,
    },
  },
  {
    name: 'Whiskey Sour',
    ingredients: ['whiskey', 'lemon', 'simple syrup', 'egg white'],
    strength: 2,
    signature: true,
    nonalcoholic: false,
  },
  {
    name: 'Long Island Iced Tea',
    ingredients: [
      'gin',
      'tequila',
      'vodka',
      'rum',
      'Cointreau',
      'simple syrup',
      'lemon',
      'cola',
    ],
    strength: 3,
    signature: true,
    nonalcoholic: false,
  },
  {
    name: 'Seda de Naranja',
    ingredients: ['tequila', 'Cointreau', 'orange bitters', 'champagne'],
    strength: 3,
    signature: true,
    nonalcoholic: false,
    recipe: { tequila: 1, Cointreau: 1, 'orange bitters': 0.5, champagne: 1 },
  },
  {
    name: "Bobbi Jo's Gimlet",
    ingredients: ['gin', 'lime', 'simple syrup'],
    strength: 2,
    signature: true,
    nonalcoholic: false,
  },
  {
    name: 'Old Fashioned',
    ingredients: ['whiskey', 'bitters', 'water', 'sugar'],
    strength: 3,
    signature: true,
    nonalcoholic: false,
    recipe: { whiskey: 2, bitters: 0.5, water: 0.5, sugar: 0.5 },
  },
  {
    name: 'Aperol Spritz',
    ingredients: ['champagne', 'aperol', 'club soda'],
    strength: 1,
    signature: true,
    nonalcoholic: false,
    recipe: { aperol: 1, champagne: 2, 'club soda': 1 },
  },
  {
    name: 'Tom Collins',
    ingredients: ['gin', 'simple syrup', 'lemon', 'club soda', 'bitters'],
    strength: 1,
    signature: true,
    nonalcoholic: false,
  },

  // ── Gin ───────────────────────────────────────────────────
  {
    name: 'Negroni',
    ingredients: ['gin', 'sweet vermouth', 'campari'],
    strength: 3,
    signature: false,
    nonalcoholic: false,
  },
  {
    name: 'Dry Martini',
    ingredients: ['gin', 'dry vermouth'],
    strength: 4,
    signature: false,
    nonalcoholic: false,
  },
  {
    name: 'Aviation',
    ingredients: ['gin', 'maraschino', 'lemon'],
    strength: 3,
    signature: false,
    nonalcoholic: false,
    recipe: { gin: 3, maraschino: 1, lemon: 1 },
  },
  {
    name: 'French 75',
    ingredients: ['gin', 'champagne', 'lemon', 'simple syrup'],
    strength: 2,
    signature: false,
    nonalcoholic: false,
  },
  {
    name: 'Gin Fizz',
    ingredients: ['gin', 'lemon', 'club soda', 'simple syrup'],
    strength: 1,
    signature: false,
    nonalcoholic: false,
  },
  {
    name: 'Gin Rickey',
    ingredients: ['gin', 'lime', 'simple syrup', 'club soda'],
    strength: 2,
    signature: false,
    nonalcoholic: false,
  },
  {
    name: 'Gin Daisy',
    ingredients: ['gin', 'lemon', 'grenadine', 'simple syrup', 'club soda'],
    strength: 2,
    signature: false,
    nonalcoholic: false,
  },
  {
    name: 'Gin Sour',
    ingredients: ['gin', 'lemon', 'simple syrup'],
    strength: 3,
    signature: false,
    nonalcoholic: false,
  },
  {
    name: 'Martinez',
    ingredients: ['gin', 'sweet vermouth', 'bitters', 'maraschino'],
    strength: 3,
    signature: false,
    nonalcoholic: false,
    recipe: { gin: 1, 'sweet vermouth': 4, bitters: 0.5, maraschino: 0.5 },
  },
  {
    name: 'White Lady',
    ingredients: ['gin', 'Cointreau', 'lemon'],
    strength: 3,
    signature: false,
    nonalcoholic: false,
  },
  {
    name: 'Vesper',
    ingredients: ['gin', 'vodka', 'lillet blanc'],
    strength: 4,
    signature: false,
    nonalcoholic: false,
  },
  {
    name: 'Fitzgerald',
    ingredients: ['gin', 'lemon', 'simple syrup', 'bitters'],
    strength: 2,
    signature: false,
    nonalcoholic: false,
  },
  {
    name: 'Bitter French',
    ingredients: ['gin', 'campari', 'lemon', 'simple syrup', 'champagne'],
    strength: 2,
    signature: false,
    nonalcoholic: false,
    recipe: { gin: 4, campari: 1, lemon: 2, 'simple syrup': 2, champagne: 1 },
  },
  {
    name: 'Mojito',
    ingredients: ['rum', 'lime', 'simple syrup', 'mint', 'club soda'],
    strength: 2,
    signature: false,
    nonalcoholic: false,
    recipe: { rum: 2, lime: 1, 'simple syrup': 0.75, 'club soda': 3 },
  },

  // ── Whiskey ───────────────────────────────────────────────
  {
    name: 'Manhattan',
    ingredients: ['whiskey', 'sweet vermouth', 'bitters'],
    strength: 3,
    signature: false,
    nonalcoholic: false,
  },
  {
    name: 'Ward Eight',
    ingredients: ['whiskey', 'simple syrup', 'lemon', 'grenadine'],
    strength: 2,
    signature: false,
    nonalcoholic: false,
  },
  {
    name: 'Mark Twain Cocktail',
    ingredients: ['whiskey', 'lemon', 'simple syrup', 'bitters'],
    strength: 2,
    signature: false,
    nonalcoholic: false,
  },
  {
    name: 'New York Sour',
    ingredients: ['whiskey', 'red wine', 'lemon', 'simple syrup'],
    strength: 2,
    signature: false,
    nonalcoholic: false,
    recipe: { whiskey: 8, 'red wine': 1, lemon: 4, 'simple syrup': 4 },
  },
  {
    name: 'Revolver',
    ingredients: ['whiskey', 'coffee liqueur', 'orange bitters'],
    strength: 4,
    signature: false,
    nonalcoholic: false,
    recipe: { whiskey: 4, 'coffee liqueur': 1, 'orange bitters': 0.5 },
  },
  {
    name: 'Scofflaw',
    ingredients: [
      'whiskey',
      'dry vermouth',
      'lemon',
      'grenadine',
      'orange bitters',
    ],
    strength: 3,
    signature: false,
    nonalcoholic: false,
    recipe: {
      whiskey: 8,
      'dry vermouth': 4,
      lemon: 1,
      grenadine: 0.5,
      'orange bitters': 0.5,
    },
  },
  {
    name: 'Boulevardier',
    ingredients: ['whiskey', 'sweet vermouth', 'campari'],
    strength: 3,
    signature: false,
    nonalcoholic: false,
    recipe: { whiskey: 1, 'sweet vermouth': 1, campari: 1 },
  },
  {
    name: 'Godfather',
    ingredients: ['whiskey', 'amaretto'],
    strength: 3,
    signature: false,
    nonalcoholic: false,
    recipe: { whiskey: 2, amaretto: 1 },
  },

  // ── Rum ───────────────────────────────────────────────────
  {
    name: 'Daiquiri',
    ingredients: ['rum', 'lime', 'simple syrup'],
    strength: 2,
    signature: false,
    nonalcoholic: false,
  },
  {
    name: 'Cuba Libre',
    ingredients: ['rum', 'lime', 'cola'],
    strength: 1,
    signature: false,
    nonalcoholic: false,
  },
  {
    name: 'El Presidente',
    ingredients: ['rum', 'dry vermouth', 'Cointreau', 'grenadine'],
    strength: 3,
    signature: false,
    nonalcoholic: false,
  },
  {
    name: 'Rum Sunset',
    ingredients: ['rum', 'lime', 'grenadine'],
    strength: 3,
    signature: false,
    nonalcoholic: false,
    recipe: { rum: 4.5, lime: 2, grenadine: 1 },
  },
  {
    name: 'American Flyer',
    ingredients: ['champagne', 'rum', 'lime', 'sugar'],
    strength: 2,
    signature: false,
    nonalcoholic: false,
  },

  // ── Vodka ─────────────────────────────────────────────────
  {
    name: 'Vodkatini',
    ingredients: ['vodka', 'dry vermouth'],
    strength: 4,
    signature: false,
    nonalcoholic: false,
  },
  {
    name: 'Black Russian',
    ingredients: ['vodka', 'coffee liqueur'],
    strength: 3,
    signature: false,
    nonalcoholic: false,
    recipe: { vodka: 2, 'coffee liqueur': 1 },
  },
  {
    name: 'Kamikaze',
    ingredients: ['vodka', 'Cointreau', 'lime'],
    strength: 3,
    signature: false,
    nonalcoholic: false,
  },
  {
    name: 'Cosmopolitan',
    ingredients: ['vodka', 'Cointreau', 'lime', 'cranberry juice'],
    strength: 2,
    signature: false,
    nonalcoholic: false,
    recipe: { vodka: 3, Cointreau: 1, lime: 0.5, 'cranberry juice': 1 },
  },
  {
    name: 'Moscow Mule',
    ingredients: ['vodka', 'lime', 'ginger beer'],
    strength: 2,
    signature: false,
    nonalcoholic: false,
    recipe: { vodka: 2, lime: 0.5, 'ginger beer': 4 },
  },
  {
    name: 'Espresso Martini',
    ingredients: ['vodka', 'coffee liqueur', 'coffee', 'simple syrup'],
    strength: 3,
    signature: false,
    nonalcoholic: false,
    recipe: { vodka: 2, 'coffee liqueur': 1, coffee: 1, 'simple syrup': 0.5 },
  },

  // ── Tequila ───────────────────────────────────────────────
  {
    name: 'Margarita',
    ingredients: ['tequila', 'Cointreau', 'lime'],
    strength: 3,
    signature: false,
    nonalcoholic: false,
  },
  // {
  //   name: 'Paloma',
  //   ingredients: ['tequila', 'lime', 'grapefruit soda', 'simple syrup'],
  //   strength: 2,
  //   signature: false,
  //   nonalcoholic: false,
  //   recipe: {
  //     tequila: 2,
  //     lime: 0.5,
  //     'grapefruit soda': 4,
  //     'simple syrup': 0.5,
  //   },
  // },
  {
    name: 'Mexican Firing Squad',
    ingredients: ['tequila', 'lime', 'grenadine', 'bitters'],
    strength: 3,
    signature: false,
    nonalcoholic: false,
  },
  {
    name: 'Brave Bull',
    ingredients: ['tequila', 'coffee liqueur'],
    strength: 3,
    signature: false,
    nonalcoholic: false,
    recipe: { tequila: 1, 'coffee liqueur': 1 },
  },

  // ── Campari / Aperitif ────────────────────────────────────
  {
    name: 'Aperol Fizz',
    ingredients: ['champagne', 'aperol'],
    strength: 1,
    signature: false,
    nonalcoholic: false,
    recipe: { aperol: 1, champagne: 3 },
  },
  {
    name: 'Americano',
    ingredients: ['campari', 'sweet vermouth', 'club soda'],
    strength: 2,
    signature: false,
    nonalcoholic: false,
  },
  {
    name: 'Negroni Sbagliato',
    ingredients: ['campari', 'sweet vermouth', 'champagne'],
    strength: 2,
    signature: false,
    nonalcoholic: false,
    recipe: { campari: 1, 'sweet vermouth': 1, champagne: 1 },
  },
  {
    name: 'Bicicletta',
    ingredients: ['campari', 'white wine', 'club soda'],
    strength: 1,
    signature: false,
    nonalcoholic: false,
    recipe: { campari: 1, 'white wine': 2, 'club soda': 1 },
  },

  // ── Amaretto ──────────────────────────────────────────────
  {
    name: 'Amaretto Sour',
    ingredients: ['amaretto', 'lemon', 'simple syrup', 'egg white'],
    strength: 2,
    signature: false,
    nonalcoholic: false,
    recipe: { amaretto: 2, lemon: 1, 'simple syrup': 0.25, 'egg white': 1 },
  },
  {
    name: 'French Connection',
    ingredients: ['cognac', 'amaretto'],
    strength: 3,
    signature: false,
    nonalcoholic: false,
    recipe: { cognac: 2, amaretto: 1 },
  },

  // ── Wine-based ────────────────────────────────────────────
  {
    name: 'The St. Germain Cocktail',
    ingredients: ['St. Germain', 'champagne', 'club soda'],
    strength: 1,
    signature: false,
    nonalcoholic: false,
  },
  {
    name: 'Campari Fizz',
    ingredients: ['campari', 'champagne'],
    strength: 2,
    signature: false,
    nonalcoholic: false,
    recipe: { campari: 1, champagne: 4 },
  },
  {
    name: 'Claret Lemonade',
    ingredients: ['red wine', 'lemon', 'simple syrup'],
    strength: 1,
    signature: false,
    nonalcoholic: false,
    recipe: { 'red wine': 8, lemon: 1.5, 'simple syrup': 2 },
  },
  {
    name: 'Clipper',
    ingredients: ['rum', 'dry vermouth', 'grenadine'],
    strength: 3,
    signature: false,
    nonalcoholic: false,
    recipe: { rum: 2, 'dry vermouth': 2, grenadine: 1 },
    notes: 'Fills 1/2 flute. Strong, but not harsh',
  },
];
